Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeNcssTable = void 0;
exports.mergeNcssTable = {
  m: ['marginLeft', 'marginRight', 'marginTop', 'marginBottom'],
  margin: ['marginLeft', 'marginRight', 'marginTop', 'marginBottom'],
  mb: ['marginBottom'],
  ml: ['marginLeft'],
  mr: ['marginRight'],
  mt: ['marginTop'],
  mx: ['marginLeft', 'marginRight'],
  my: ['marginTop', 'marginBottom'],
  p: ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'],
  padding: ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'],
  pb: ['paddingBottom'],
  pl: ['paddingLeft'],
  pr: ['paddingRight'],
  pt: ['paddingTop'],
  px: ['paddingLeft', 'paddingRight'],
  py: ['paddingTop', 'paddingBottom']
};